

























import {Component, Prop, Vue} from "vue-property-decorator";
import KInput from "../components/KInput.vue";
import AdminNav from "../components/TopNav.vue";
import TopNav from "../components/AdminNav.vue";
import moment from "moment";
import CalendarEvent from "../models/CalendarEvent";
import {DATE_FORMAT, DATETIME_FORMAT, TIME_FORMAT} from "../models/Model";
import axios from "axios";
import queryString from "query-string";
import {apiGet, getConfig, me, verifyAuth} from "../session";
import {Settings} from "../models/Settings";

interface Week {
    start: moment.Moment;
    events: CalendarEvent[];
}

@Component({
    components: {KInput, AdminNav, TopNav},
})
export default class EventList extends Vue {
    protected weeks: Week[] = [];
    protected weekStart: moment.Moment = moment().add(-1, "months").startOf("week");
    protected weekEnd: moment.Moment = moment().add(2, "months").endOf("week");

    public created() {
        verifyAuth();
        this.weeks.length = 0;
        let now = this.weekStart.clone();
        while (now.isBefore(this.weekEnd)) {
            const week: Week = {
                start: now,
                events: [],
            };
            this.weeks.push(week);
            this.fetchWeek(week);
            now = now.clone().add(1, "week");
        }
    }

    protected fetchWeek(week: Week) {
        const startStr = week.start.format(DATE_FORMAT);
        const endStr = week.start.clone().add(6, "days").format(DATE_FORMAT);
        apiGet(`/events?from=${startStr}&end=${endStr}`).then((evts) => {
            for (const evt of evts) {
                week.events.push(CalendarEvent.fromJson(evt));
            }
            week.events.sort();
        });
    }

    protected loadMore() {
        let latest = this.weeks.slice(-1)[0].start.clone().add(1, "week");
        this.weekEnd.add(8, "weeks");
        while (latest.isBefore(this.weekEnd)) {
            const week: Week = {
                start: latest,
                events: [],
            };
            this.weeks.push(week);
            this.fetchWeek(week);
            latest = latest.clone().add(1, "week");
        }
    }

    protected loadEarlier() {
        let earliest = this.weeks[0].start.clone().add(-1, "week");
        this.weekStart.add(-8, "weeks");
        while (earliest.isSameOrAfter(this.weekStart)) {
            const week: Week = {
                start: earliest,
                events: [],
            };
            this.weeks.unshift(week);
            this.fetchWeek(week);
            earliest = earliest.clone().add(-1, "week");
        }
    }

    protected weekName(start: moment.Moment) {
        const end = start.clone().add(6, "days");
        if (start.month() === end.month()) {
            return start.format("D") + " - " + end.format("D MMM, YY");
        } else {
            return start.format("D MMM") + " - " + end.format("D MMM, YY");
        }
    }
}
